<template>
  <div>
    <h2>{{ repo.title }}</h2>
    <h3>{{ repo.version }}</h3>
    <div class="author">
      {{ repo.author.screen_name }}
      <template v-if="repo.published_at"
        >发布于 {{ repo.published_at | parseTime }}</template
      >
    </div>
    <div class="mt-10">
      <template v-for="(tag, idx) of repo.tags">
        <el-tag :key="idx" size="mini" type="info">{{ tag.name }}</el-tag>
      </template>
    </div>
    <hr />
    <TextEditorPreview :content="repo.readme"></TextEditorPreview>
    <hr />
    <h4>Archives:</h4>
    <ArchivesList :archives="repo.archives"></ArchivesList>
  </div>
</template>

<script>
import { RepoMixin, ParseTimeFilterMixin } from "@/mixins";
import TextEditorPreview from "@/components/TextEditorPreview";
import ArchivesList from "@/components/ArchivesList";
export default {
  name: "RepoPreview",
  props: ["repo_id"],
  mixins: [RepoMixin, ParseTimeFilterMixin],
  components: {
    TextEditorPreview,
    ArchivesList
  },
  computed: {
    repoID() {
      return this.repo_id;
    }
  }
};
</script>
